const bus_dict = {
	"HIS_CHARGE_INVOICE_TYPE": {
		"uniqNo": "5001",
		"name": "发票类型"
	},
	"HIS_SATISFACTION": {
		"uniqNo": "5004",
		"name": "满意度"
	},
	"HIS_PATIENT_TREATMENT_PHASE": {
		"uniqNo": "5005",
		"name": "治疗阶段"
	},
	"HIS_PATIENT_MARKET_CHANNEL": {
		"uniqNo": "5006",
		"name": "来源渠道"
	},
	"HIS_PATIENT_FOLLOWUP_TYPE": {
		"uniqNo": "5007",
		"name": "随访类型"
	},
	"HIS_PATIENT_CONTACT_WAY": {
		"uniqNo": "5008",
		"name": "联系方式类型"
	},
	"HIS_PATIENT_FRIENDS_FAMILY_RELATIONS": {
		"uniqNo": "5009",
		"name": "亲友关系类型"
	},
	"HIS_APPOINT_VISIT_TYPE": {
		"uniqNo": "5010",
		"name": "就诊类型"
	},
	"HIS_PATIENT_PAST_HISTORY": {
		"uniqNo": "5011",
		"name": "既往史"
	},
	"HIS_PATIENT_ALLERGIC_HISTORY": {
		"uniqNo": "5012",
		"name": "过敏史"
	},
	"HIS_PATIENT_DRUG_HISTORY": {
		"uniqNo": "5013",
		"name": "现用药情况"
	},
	"HIS_PATIENT_CHIEF_COMPLAINT": {
		"uniqNo": "5014",
		"name": "就诊主诉"
	},
	"HIS_CHARGE_NO_CHARGE_CAUSE": {
		"uniqNo": "5015",
		"name": "未收费原因"
	},
	"HIS_CHARGE_REFUND_CREDIT_CAUSE": {
		"uniqNo": "5016",
		"name": "退费减免原因"
	},
	"HIS_CHARGE_CANCEL_CAUSE": {
		"uniqNo": "5017",
		"name": "账单作废原因"
	},
	"HIS_ACCOUNT_BALANCE_REFUND_CAUSE": {
		"uniqNo": "5018",
		"name": "账户余额退费原因"
	},
	"HIS_NATIONALITY": {
		"uniqNo": "5019",
		"name": "国籍"
	},
	"HIS_PROFESSIONAL_TITLE": {
		"uniqNo": "5020",
		"name": "职称"
	},
	"HIS_TRANSACT_INTENT": {
		"uniqNo": "5021",
		"name": "成交意愿"
	},
	"HIS_FOLLOW_INSTRUCTIONS": {
		"uniqNo": "5022",
		"name": "跟进说明"
	},
	"HIS_TEETH_CLEANING_WAY": {
		"uniqNo": "5023",
		"name": "洁牙方式"
	},
	"HIS_ANESTHESIA": {
		"uniqNo": "5024",
		"name": "麻醉方式"
	},
	"HIS_COMMUNICATION_MODE": {
		"uniqNo": "5027",
		"name": "沟通方式"
	},
	"HIS_INTENTION_INSTRUCTIONS": {
		"uniqNo": "5028",
		"name": "意向说明"
	},
	"HIS_APPOINT_CANCEL_CAUSE": {
		"uniqNo": "5029",
		"name": "预约取消原因"
	},
	"HIS_CLINIC_DISTRICT": {
		"uniqNo": "5030",
		"name": "门店区域"
	},
	"HIS_CHARGE_TRANSACTION_CANCEL_CAUSE": {
		"uniqNo": "5031",
		"name": "交易作废原因"
	},
	"HIS_PATIENT_RETURN_VISIT_TYPE": {
		"uniqNo": "5032",
		"name": "回访类型"
	},
	"HIS_PATIENT_RETURN_VISIT_CONTENT": {
		"uniqNo": "5033",
		"name": "回访内容"
	},
	"HIS_PATIENT_MODIFIED_TOOTH_BIT_CAUSE": {
		"uniqNo": "5034",
		"name": "处置修改牙位原因"
	},
	"HIS_CHARGE_REVOKE_CAUSE": {
		"uniqNo": "5035",
		"name": "账单撤单原因"
	},
	"HIS_INTRAORAL_INSPECTION_RESULT": {
		"uniqNo": "5036",
		"name": "口内检查结果"
	},
	"HIS_CHARGE_ITEM_KPI_TYPE": {
		"uniqNo": "5037",
		"name": "收费项目业绩分类"
	},
	"WM_MANUFACTURER": {
		"uniqNo": "5038",
		"name": "生产厂商"
	},
	"WM_BRAND": {
		"uniqNo": "5039",
		"name": "品牌"
	},
	"WM_UNITS": {
		"uniqNo": "5040",
		"name": "单位"
	},
	"WM_ENTERPRISE_NATURE": {
		"uniqNo": "5041",
		"name": "企业性质"
	},
	"WM_SETTLEMENT_MODES": {
		"uniqNo": "5042",
		"name": "结算方式"
	},
	"WM_CERTIFICATION_CATEGORY": {
		"uniqNo": "5043",
		"name": "资质类型"
	},
	"WM_PRODUCT_CATEGORY": {
		"uniqNo": "5044",
		"name": "物品类型"
	},
	"WM_WAREHOUSE_IM_EX_CAUSE": { "uniqNo": "5045", "name": "收退损原因" },
	"SC_LOGISTICS_COMPANY": { "uniqNo": "5046", "name": "物流公司" },
	"HIS_OTHER_ID_TYPE": { "uniqNo": "5047", "name": "其他证件" },
	"DENTALLAB_TRY_ON_ITEM": { "uniqNo": "5048", "name": "试戴内容" },
	"DENTALLAB_TOOTH_COLOR": { "uniqNo": "5049", "name": "牙色" },
	"DENTALLAB_REWORK_RESON": { "uniqNo": "5050", "name": "返工原因" },
	"COUPON_CANCEL_RESON": { "uniqNo": "5051", "name": "卡券注销原因" },
	"HIS_EMR_SKIP_APPLY_RESON": { "uniqNo": "5052", "name": "跳过写病历申请原因" },
	"HIS_EMR_REJECT_RESON": { "uniqNo": "5053", "name": "病历质控驳回原因" },
	"HIS_PATIENT_CONSULT_CANCEL_REASON":{"uniqNo":"5054","name":"患者二次回访任务取消原因"},
	// "HIS_CLINIC_MEDICALLY_PERIOD":{"uniqNo":"5055","name":"体检时段"},
	"HIS_ADVERSE_EVENT_CLASSIFICATION":{"uniqNo":"5055","name":"事件分级"},
	"HIS_ADVERSE_EVENT_HANDLE":{"uniqNo":"5056","name":"事件处理结果"},
	"HIS_ADVERSE_EVENT_FEEDBACK":{"uniqNo":"5057","name":"投诉反馈方式"},
	"HIS_ADVERSE_EVENT_SATISFACTION":{"uniqNo":"5058","name":"满意度"},
	"HIS_EMR_PRINT_REASON": { "uniqNo":"5059", "name": "打印/复印原因" },
    "HIS_CHARGE_REFUND_RECHARGE_REASON": { "uniqNo":"5060", "name": "退费重收原因" },
	'HIS_APPOINT_RESCHEDULE_REASON':{ "uniqNo":"5061", "name": "改约原因"},
	"HIS_PATIENT_WORK_UNIT": {"uniqNo": "5064","name": "工作单位"},
	"HIS_PATIENT_POINT_GIFT_REASON": {"uniqNo": "5065","name": "赠送原因"},
	"HIS_WARRANTY_CARD_EXTEND_REASON": {"uniqNo": "5066","name": "延保原因"},
	"HIS_APPOINT_CHANNEL": {"uniqNo": "5071","name": "预约渠道"},
	"HIS_PATIENT_CONCERN_PROBLEMS":{"uniqNo":"5072","name":"诊疗登记患者关心的问题"},
	"HIS_PATIENT_FOLLOW_GOAL": {"uniqNo": "5073","name": "患者跟进目标"},
	"HIS_CHARGE_TYPE": {"uniqNo": "5074","name": "技耗分类"},
	"HIS_LEAD_CONSULT_ITEM": {"uniqNo": "5075","name": "线索咨询项目"},
	"HIS_CHARGE_PREVENTIVE_SOURCE": {"uniqNo": "5076","name": "预防客户来源"},
	"HIS_LEAD_FOLLOW_GOAL": {"uniqNo": "5077","name": "线索跟进目标"},
	"HIS_WECOM_FOLLOW_GOAL": {"uniqNo": "5078","name": "企微好友跟进目标"},
	"HIS_MEDICAL_INSURANCE_CERT_TYPE": { "uniqNo": "5079", "name": "医保资质文件类型" },
	"HIS_PATIENT_PREVENT_DEMAND": { "uniqNo": "5080", "name": "患者预防购买需求" },
}	

const sys_dict = {
	"SEX": {
		"uniqNo": "1001",
		"name": "性别"
	},
	"MENU_CATEGORY": {
		"uniqNo": "1002",
		"name": "菜单类型"
	},
	"NOTICE": {
		"uniqNo": "1003",
		"name": "通知类型"
	},
	"BUTTON_FUNC": {
		"uniqNo": "1004",
		"name": "按钮功能"
	},
	"YES_NO": {
		"uniqNo": "1005",
		"name": "是否"
	},
	"FLOW": {
		"uniqNo": "1006",
		"name": "流程类型"
	},
	"ORG_CATEGORY": {
		"uniqNo": "1007",
		"name": "机构类型"
	},
	"DATA_SCOPE_TYPE": {
		"uniqNo": "1008",
		"name": "数据权限"
	},
	"API_SCOPE_TYPE": {
		"uniqNo": "1009",
		"name": "接口权限"
	},
	"SCOPE_CATEGORY": {
		"uniqNo": "1010",
		"name": "权限类型"
	},
	"OSS": {
		"uniqNo": "1011",
		"name": "对象存储类型"
	},
	"SMS": {
		"uniqNo": "1012",
		"name": "短信服务类型"
	},
	"POST_CATEGORY": {
		"uniqNo": "1013",
		"name": "岗位类型"
	},
	"REGION": {
		"uniqNo": "1014",
		"name": "行政区划"
	},
	"USER_TYPE": {
		"uniqNo": "1015",
		"name": "用户平台"
	},
	"SYS_PRESET_FLAG": {
		"uniqNo": "2001",
		"name": "系统预设"
	},
	"MENU_SCOPE": {
		"uniqNo": "2002",
		"name": "作用域"
	},
	"ROLE_TYPE": {
		"uniqNo": "2003",
		"name": "角色类型"
	},
	"IS_DELETED": {
		"uniqNo": "2004",
		"name": "逻辑删除"
	},
	"HIS_SCHEDULE_WEEK": {
		"uniqNo": "2005",
		"name": "星期"
	},
	"STATUS": {
		"uniqNo": "2006",
		"name": "状态"
	},
	"HIS_APPOINT_OPERATION_ITEM_TYPE": {
		"uniqNo": "2007",
		"name": "手术项目类型"
	},
	"HIS_APPOINT_STATUS": {
		"uniqNo": "2008",
		"name": "预约状态"
	},
	"HIS_AMPM": {
		"uniqNo": "2009",
		"name": "班别"
	},
	"HIS_IS_ON_DUTY": {
		"uniqNo": "2010",
		"name": "是否值班"
	},
	"HIS_FIELD_SCOPE": {
		"uniqNo": "2011",
		"name": "字段作用域"
	},
	"HIS_JOB_STATUS": {
		"uniqNo": "2012",
		"name": "在职状态"
	},
	"HIS_IS_REQUIRED": {
		"uniqNo": "2013",
		"name": "是否必填"
	},
	"HIS_CHARGE_PAYMEN_TYPE": {
		"uniqNo": "2014",
		"name": "支付方式分类"
	},
	"HIS_IS_INIT": {
		"uniqNo": "2015",
		"name": "是否初始化"
	},
	"HIS_CLINIC_TYPE": {
		"uniqNo": "2016",
		"name": "诊所类型"
	},
	"HIS_CLINIC_DIAGNOSE_ITEM_TYPE": {
		"uniqNo": "2017",
		"name": "诊断项目类型"
	},
	"HIS_IS_DEFAULT": {
		"uniqNo": "2018",
		"name": "默认工作场所"
	},
	"HIS_GLOBAL_STATUS": {
		"uniqNo": "2019",
		"name": "问题状态"
	},
	"HIS_GLOBAL_ACCEPT_HANDLE_TIME": {
		"uniqNo": "2020",
		"name": "接受问题处理时间"
	},
	"HIS_GLOBAL_ISSUE_TYPE": {
		"uniqNo": "2021",
		"name": "问题反馈"
	},
	"HIS_GLOBAL_OPERATE_TYPE": {
		"uniqNo": "2022",
		"name": "操作类型"
	},
	"HIS_GLOBAL_OPERATE_STATUS": {
		"uniqNo": "2023",
		"name": "操作状态"
	},
	"HIS_PATIENT_STATUS": {
		"uniqNo": "2024",
		"name": "患者状态"
	},
	"HIS_MARRIAGE": {
		"uniqNo": "2025",
		"name": "婚姻"
	},
	"HIS_EDUCATIONAL_LEVEL": {
		"uniqNo": "2026",
		"name": "文化程度"
	},
	"HIS_PATIENT__IS_REPAIR_HIS": {
		"uniqNo": "2027",
		"name": "修复史"
	},
	"HIS_PATIENT_BRUSH_DURATION": {
		"uniqNo": "2028",
		"name": "刷牙时长"
	},
	"HIS_PATIENT_BRUSH_FREQUENCY": {
		"uniqNo": "2029",
		"name": "刷牙频次"
	},
	"HIS_PATIENT_SMOKE_FREQUENCY": {
		"uniqNo": "2030",
		"name": "吸烟频次"
	},
	"HIS_PATIENT_IS_LIKE_HARD_FOOT": {
		"uniqNo": "2031",
		"name": "喜硬食"
	},
	"HIS_PATIENT_IS_BRUXISM": {
		"uniqNo": "2032",
		"name": "夜磨牙"
	},
	"HIS_PATIENT_IS_TOOTH_EXTRACTION_HIS": {
		"uniqNo": "2033",
		"name": "拔牙史"
	},
	"HIS_PATIENT_IS_ORTHODONTIC_HIS": {
		"uniqNo": "2034",
		"name": "正畸史"
	},
	"HIS_PATIENT_IS_IMPLANT_TEETH_HIS": {
		"uniqNo": "2035",
		"name": "种牙史"
	},
	"HIS_PATIENT_IS_FILL_TEETH_HIS": {
		"uniqNo": "2036",
		"name": "补牙史"
	},
	"HIS_PATIENT_LABEL_TYPE": {
		"uniqNo": "2037",
		"name": "标签类型"
	},
	"HIS_PATIENT_GROUP_TYPE": {
		"uniqNo": "2038",
		"name": "患者分组类型"
	},
	"HIS_COMPLICATION_FLAG": {
		"uniqNo": "2039",
		"name": "是否有术后并发症"
	},
	"HIS_PATIENT_MEDICAL_TEMPLATES": {
		"uniqNo": "2040",
		"name": "病历模板字段"
	},
	"HIS_RECIPE_CHARGE_STATUS": {
		"uniqNo": "2041",
		"name": "处方状态"
	},
	"HIS_CHARGE_BILL_TYPE": {
		"uniqNo": "2042",
		"name": "账单类型"
	},
	"HIS_CHARGE_BILL_STATUS": {
		"uniqNo": "2043",
		"name": "账单状态"
	},
	"HIS_CHARGE_TRANSACTION_TYPE": {
		"uniqNo": "2044",
		"name": "交易类型"
	},
	"HIS_CHARGE_TRANSACTION_STATUS": {
		"uniqNo": "2045",
		"name": "交易状态"
	},
	"HIS_USAGE_STATE": {
		"uniqNo": "2046",
		"name": "使用状态"
	},
	"HIS_WORK_STATE": {
		"uniqNo": "2047",
		"name": "工作状态"
	},
	"HIS_FOLLOW_UP_PLAN_DATE_SHIFT_UNIT": {
		"uniqNo": "2048",
		"name": "计划时间偏移单位"
	},
	"HIS_FOLLOW_UP_PLAN_STATE": {
		"uniqNo": "2049",
		"name": "随访计划状态"
	},
	"HIS_FOLLOW_UP_CREATE_MODE": {
		"uniqNo": "2050",
		"name": "创建随访模式"
	},
	"HIS_FOLLOW_UP_DATE_MODE": {
		"uniqNo": "2051",
		"name": "随访时间模式"
	},
	"HIS_CONSULTING_WAY": {
		"uniqNo": "2052",
		"name": "咨询方式"
	},
	"HIS_FOLLOW_UP_STATE": {
		"uniqNo": "2053",
		"name": "随访状态"
	},
	"HIS_IS_PART_JOB": {
		"uniqNo": "2054",
		"name": "是否兼职"
	},
	"HIS_APPOINT_TYPE": {
		"uniqNo": "2055",
		"name": "预约类型"
	},
	"HIS_CHARGE_EXECUTION_STEP_STATE": {
		"uniqNo": "2056",
		"name": "执行步骤状态"
	},
	"HIS_TRANSFERING_CONSULTATION_TYPE": {
		"uniqNo": "2057",
		"name": "转诊类型"
	},
	"HIS_CHARGE_EXECUTION_METHOD": {
		"uniqNo": "2058",
		"name": "划扣执行方式"
	},
	"HIS_PATIENT_IMAGE_TYPE": {
		"uniqNo": "2059",
		"name": "影像类型"
	},
	"HIS_PATIENT_FOLLOWUP_DOCTOR_TYPE": {
		"uniqNo": "2060",
		"name": "随访医生类型"
	},
	"HIS_PATIENT_FOLLOWUP_STAFF_TYPE": {
		"uniqNo": "2061",
		"name": "随访人员类型"
	},
	"HIS_PATIENT_RETURN_VISIT_STATUS": {
		"uniqNo": "2062",
		"name": "回访状态"
	},
	"WM_PRICETYPE": {
		"uniqNo": "2063",
		"name": "计价方式"
	},
	"WM_IM_WAREHOUSING": {
		"uniqNo": "2064",
		"name": "入库类型"
	},
	"WM_EX_WAREHOUSE": {
		"uniqNo": "2065",
		"name": "出库类型"
	},
	"WM_WAREHOUSE_RECEIPT_STATE": {
		"uniqNo": "2066",
		"name": "仓单状态"
	},
	"WM_WAREHOUSE_IM_EX_UNITS": {
		"uniqNo": "2067",
		"name": "收退货单位"
	},
	"DENTALLAB_ORDER_STATUS": {
		"uniqNo": "2068",
		"name": "技加工订单状态"
	},
	"DENTALLAB_ORDER_SETTLEMENT_STATUS": {
		"uniqNo": "2069",
		"name": "技加工订单结算状态"
	},
	"DENTALLAB_ORDER_TYPE": {
		"uniqNo": "2070",
		"name": "技加工订单类型"
	},
	"DENTALLAB_SETTLEMENT_STATUS": {
		"uniqNo": "2071",
		"name": "对账单结算状态"
	},
	"SMS_EXAMINE_STATUS": {
		"uniqNo": "2072",
		"name": "短信审核状态"
	},
	"SMS_TEMPLATE_CATEGORY": {
		"uniqNo": "2073",
		"name": "短信模板类型"
	},
	"SMS_SIGNATURE_STATUS": {
		"uniqNo": "2074",
		"name": "短信签名状态"
	},
	"SMS_SEND_STATUS": {
		"uniqNo": "2075",
		"name": "短信发送状态"
	},
	"EMPLOYEE_TYPE": {
		"uniqNo": "2076",
		"name": "员工类型"
	},
	"HIS_PATIENT_CONSULT_TASK_TYPE":{
		"uniqNo":"2077",
		"name": "二次回访任务类型"
	},
	"HIS_PATIENT_CONSULT_STATUS":{
		"uniqNo":"2078",
		"name": "二次回访任务状态"
	},
	"HIS_ADVERSE_EVENT_STATUS":{
		"uniqNo":"2079",
		"name": "不良事件状态"
	},
	"HIS_YIBAO_TYPE":{
		"uniqNo":"2080",
		"name": "医保情况"
	},
	"HIS_WECOM_AGENT_TYPE": { "uniqNo":"2082", "name": "企微应用类型"},
	"HIS_CLINIC_STATUS":{"uniqNo":"2085", "name":"营业状态"},
	"HIS_PATIENT_IDCARD_TYPE": { "uniqNo":"2086", "name": "患者证件类型" },
	"HIS_CLINIC_PRACTICE_CATEGORY": { "uniqNo":"2087", "name": "医生执业类别" },
	"HIS_CLINIC_PRACTICE_SCOPE": { "uniqNo":"2088", "name": "医生执业范围" },
}

export default {
	bus_dict,
	sys_dict
}
